import { PATHS, ELEMENT_TYPE } from '../config/constants';
import translations from './index';

const { productDesc, humanNames, general } = translations;

export default {
  PR01: {
    id: 'PR01',
    title: 'Joining system for transmission belt',
    text: humanNames.HD01,
    year: '1921',
    theme: 'black',
    description: productDesc.PR01,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR01/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR01/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR01/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD01`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD01',
      },
    ],
    nextProduct: {
      id: 'PR02',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR02`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR02: {
    id: 'PR02',
    title: 'Braun Cosmophon 333W',
    text: 'Carl Sevecke',
    year: '1932',
    theme: 'black',
    classname: 'cosmophon',
    description: productDesc.PR02,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR02/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR02/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR02/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR02/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD01`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD01',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR02/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR09`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR09',
      },
    ],
    nextProduct: {
      id: 'PR03',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR03`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR03`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR03',
    },
  },
  PR03: {
    id: 'PR03',
    title: 'Radio-phono-combination Cosmophon 777C',
    text: humanNames.HD01,
    year: '1934',
    theme: 'black',
    classname: 'phonograph',
    description: productDesc.PR03,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR03/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR03/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR03/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR03/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD01`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD01',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR03/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR08`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601466239/max-braun/products/PR03/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR12`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR12',
      },
    ],
    nextProduct: {
      id: 'PR04',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR04`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR04`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR04',
    },
  },
  PR04: {
    id: 'PR04',
    title: 'Manulux',
    text: 'Braun Factory',
    year: '1938',
    theme: 'black',
    description: productDesc.PR04,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR04/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR04/HeroMobile.jpg',
    relatedText: '',
    type: ELEMENT_TYPE.PRODUCT,
    related: [],
    nextProduct: {
      id: 'PR05',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR05`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR05: {
    id: 'PR05',
    title: 'S 50',
    text: humanNames.HD01,
    year: '1950',
    theme: 'black',
    description: productDesc.PR05,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR05/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR05/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR05/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD01`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD01',
      },
    ],
    nextProduct: {
      id: 'PR06',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR06`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR14`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR14',
    },
  },
  PR06: {
    id: 'PR06',
    title: 'Braun Multimix Blender',
    text: 'Braun Factory',
    year: '1953',
    classname: 'multimix',
    theme: 'black',
    description: productDesc.PR06,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR06/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR06/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR06/Related.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR06/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR47`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR47',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601464848/max-braun/products/PR06/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR13`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR13',
      },
    ],
    nextProduct: {
      id: 'PR07',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR07`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR07: {
    id: 'PR07',
    title: 'Smoothy',
    text: 'Braun Factory',
    year: '1954',
    theme: 'black',
    classname: 'smoothy',
    description: productDesc.PR07,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR07/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR07/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR07/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR07/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR40`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR40',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR07/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR50`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR50',
      },
    ],
    nextProduct: {
      id: 'PR08',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR08`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR08: {
    id: 'PR08',
    title: 'Braun combi',
    text: humanNames.HD05,
    year: '1955',
    theme: 'black',
    classname: 'brauncombi',
    description: productDesc.PR08,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR08/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR08/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR08/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR08/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD05`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD05',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601466286/max-braun/products/PR08/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR12`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR12',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR08/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR03`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR03',
      },
    ],
    nextProduct: {
      id: 'PR09',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR09`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR09: {
    id: 'PR09',
    classname: 'sk1',
    title: 'SK 1',
    text: 'Artur Braun & Fritz Eichler',
    year: '1955',
    theme: 'black',
    description: productDesc.PR09,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR09/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR09/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR09/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR09/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD04`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD04',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR09/Related2.jpg',
        url: `${PATHS.DESIGNER}/HD02`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD02',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR09/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR14`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR14',
      },
    ],
    nextProduct: {
      id: 'PR10',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR10`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR10: {
    id: 'PR10',
    classname: 'fsg',
    title: 'FS-G',
    text: humanNames.HD07,
    year: '1955',
    theme: 'black',
    description: productDesc.PR10,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR10/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR10/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR10/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR11/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD07`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD07',
      },
    ],
    nextProduct: {
      id: 'PR11',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR11`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR11: {
    id: 'PR11',
    classname: 'g11',
    title: 'G 11',
    text: humanNames.HD07,
    year: '1955',
    theme: 'black',
    description: productDesc.PR11,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR11/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR11/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR11/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR11/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD07`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD07',
      },
    ],
    nextProduct: {
      id: 'PR12',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR12`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR12: {
    id: 'PR12',
    classname: 'sk4',
    title: 'SK 4',
    text: 'Hans Gugelot, Dieter Rams',
    year: '1956',
    theme: 'white',
    description: productDesc.PR12,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1601464594/max-braun/products/PR12/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1601464626/max-braun/products/PR12/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/v1601464216/max-braun/products/PR12/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR12/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR12/Related2.jpg',
        url: `${PATHS.DESIGNER}/HD07`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD07',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR12/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR16`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR16',
      },
    ],
    nextProduct: {
      id: 'PR13',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR13`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR13: {
    id: 'PR13',
    classname: 'km',
    title: 'KM3/31',
    text: 'Gerd Alfred Müller',
    year: '1957',
    theme: 'black',
    description: productDesc.PR13,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1601464753/max-braun/products/PR13/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1601464777/max-braun/products/PR13/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/v1601464752/max-braun/products/PR13/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR13/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR06`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR06',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR13/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR47`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR47',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR13/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR36`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR36',
      },
    ],
    nextProduct: {
      id: 'PR14',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR14`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR19`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR19',
    },
  },
  PR14: {
    id: 'PR14',
    classname: 't3',
    title: 'T3',
    text: 'Dieter Rams, HfG Ulm',
    year: '1958',
    theme: 'black',
    description: productDesc.PR14,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR14/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR14/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR14/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR14/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR14/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR02`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR02',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR14/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR16`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR16',
      },
    ],
    nextProduct: {
      id: 'PR15',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR15`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR13`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR13',
    },
  },
  PR15: {
    id: 'PR15',
    classname: 'le1',
    title: 'LE 1',
    text: humanNames.HD08,
    year: '1959',
    theme: 'black',
    description: productDesc.PR15,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR15/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR15/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR15/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR53`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR53',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR15/Related2.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
    ],
    nextProduct: {
      id: 'PR16',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR16`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR16: {
    id: 'PR16',
    classname: 'tp1',
    title: 'TP 1',
    text: humanNames.HD08,
    year: '1959',
    theme: 'black',
    description: productDesc.PR16,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR16/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR16/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR16/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR16/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR14`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR14',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR16/Related2.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
    ],
    nextProduct: {
      id: 'PR17',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR17`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR17: {
    id: 'PR17',
    classname: 'rt20',
    title: 'RT 20',
    text: humanNames.HD08,
    year: '1961',
    theme: 'black',
    description: productDesc.PR17,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR17/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR17/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR17/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
    ],
    nextProduct: {
      id: 'PR18',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR18`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR18: {
    id: 'PR18',
    title: 'sixtant SM 31',
    text: 'Gerd Alfred Muller, Hans Gugelot',
    year: '1962',
    theme: 'black',
    description: productDesc.PR18,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR18/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR18/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR18/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD07`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD07',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR18/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR26`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR26',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR18/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR54`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR54',
      },
    ],
    nextProduct: {
      id: 'PR19',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR19`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR05`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR05',
    },
  },
  PR19: {
    id: 'PR19',
    title: 'KSM 1/11',
    text: humanNames.HD09,
    year: '1963',
    theme: 'black',
    description: productDesc.PR19,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR19/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR19/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR19/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD09`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD09',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601465546/max-braun/products/PR19/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR28`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR28',
      },
    ],
    nextProduct: {
      id: 'PR20',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR20`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR20: {
    id: 'PR20',
    title: 'HT 2',
    text: humanNames.HD09,
    year: '1963',
    theme: 'black',
    description: productDesc.PR20,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1601465288/max-braun/products/PR20/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1601465305/max-braun/products/PR20/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR20/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD09`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD09',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR20/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR39`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR39',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR20/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR29`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR29',
      },
    ],
    nextProduct: {
      id: 'PR21',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR21`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR21: {
    id: 'PR21',
    title: 'T 1000',
    text: humanNames.HD08,
    year: '1963',
    theme: 'black',
    description: productDesc.PR21,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR21/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR21/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR21/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
    ],
    nextProduct: {
      id: 'PR22',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR22`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR22: {
    id: 'PR22',
    title: 'HLD 231',
    text: humanNames.HD09,
    year: '1964',
    theme: 'black',
    description: productDesc.PR22,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR22/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR22/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR22/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD09`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD09',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR22/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR25`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR25',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR22/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR38`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR38',
      },
    ],
    nextProduct: {
      id: 'PR24',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR24`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR24: {
    id: 'PR24',
    title: 'PS 500',
    text: humanNames.HD08,
    year: '1968',
    theme: 'black',
    description: productDesc.PR24,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR24/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR24/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR24/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR24/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR16`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR16',
      },
    ],
    nextProduct: {
      id: 'PR25',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR25`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR25: {
    id: 'PR25',
    title: 'HLD 4',
    text: humanNames.HD08,
    year: '1970',
    theme: 'black',
    description: productDesc.PR25,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR25/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR25/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR25/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR25/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR38`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR38',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR25/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR22`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR22',
      },
    ],
    nextProduct: {
      id: 'PR26',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR26`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR36`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR36',
    },
  },
  PR26: {
    id: 'PR26',
    title: 'Intercontinental',
    text: 'Florian Seiffert, Robert Oberheim',
    year: '1972',
    theme: 'black',
    description: productDesc.PR26,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR26/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR26/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR26/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR18`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR18',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR26/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR34`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR34',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR26/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR54`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR54',
      },
    ],
    nextProduct: {
      id: 'PR27',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR27`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR27: {
    id: 'PR27',
    title: 'BM 12 Lady Shaver',
    text: 'Florian Seiffert',
    year: '1972',
    theme: 'black',
    description: productDesc.PR27,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR27/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR27/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR27/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR40`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR40',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR27/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR44`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR44',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR27/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR51`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR51',
      },
    ],
    nextProduct: {
      id: 'PR28',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR28`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR28: {
    id: 'PR28',
    title: 'KF 20',
    text: 'Florian Seiffert',
    year: '1972',
    theme: 'black',
    description: productDesc.PR28,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1601465407/max-braun/products/PR28/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1601465429/max-braun/products/PR28/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR28/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR19`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR19',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR28/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR39`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR39',
      },
    ],
    nextProduct: {
      id: 'PR29',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR29`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR29: {
    id: 'PR29',
    title: 'MPZ 22',
    text: 'Jürgen Greubel, Dieter Rams',
    year: '1972',
    theme: 'black',
    description: productDesc.PR29,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR29/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR29/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR29/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601467330/max-braun/products/PR29/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR28`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR28',
      },
    ],
    nextProduct: {
      id: 'PR30',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR30`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR39`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR39',
    },
  },
  PR30: {
    id: 'PR30',
    title: 'Phase 1',
    text: 'Dieter Rams, Dietrich Lubs',
    year: '1972',
    theme: 'black',
    description: productDesc.PR30,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR30/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR30/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR30/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR30/Related2.jpg',
        url: `${PATHS.DESIGNER}/HD10`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD10',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR30/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR31`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR31',
      },
    ],
    nextProduct: {
      id: 'PR31',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR31`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR31: {
    id: 'PR31',
    title: 'Functional',
    text: humanNames.HD10,
    year: '1975',
    theme: 'black',
    description: productDesc.PR31,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR31/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR31/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR31/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD10`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD10',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR31/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR37`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR37',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR31/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR41`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR41',
      },
    ],
    nextProduct: {
      id: 'PR32',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR32`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR32: {
    id: 'PR32',
    title: 'ET 33',
    text: 'Dieter Rams, Dietrich Lubs, Ludwig Littmann',
    year: '1977',
    theme: 'black',
    description: productDesc.PR32,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR32/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR32/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR32/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR32/Related2.jpg',
        url: `${PATHS.DESIGNER}/HD10`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD10',
      },
    ],
    nextProduct: {
      id: 'PR33',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR33`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR33: {
    id: 'PR33',
    title: 'DW 30',
    text: 'Dieter Rams, Dietrich Lubs',
    year: '1978',
    theme: 'black',
    description: productDesc.PR33,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1601465646/max-braun/products/PR33/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1601465631/max-braun/products/PR33/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR33/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD08`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD08',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR33/Related2.jpg',
        url: `${PATHS.DESIGNER}/HD10`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD10',
      },
    ],
    nextProduct: {
      id: 'PR34',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR34`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR34: {
    id: 'PR34',
    title: 'Micron plus',
    text: 'Roland Ullmann',
    year: '1979',
    theme: 'black',
    description: productDesc.PR34,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR34/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR34/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601467047/max-braun/products/PR34/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR20`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR20',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR34/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR26`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR26',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR34/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR43`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR43',
      },
    ],
    nextProduct: {
      id: 'PR35',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR35`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR35: {
    id: 'PR35',
    title: 'Atelier',
    text: humanNames.HD11,
    year: '1980',
    theme: 'black',
    description: productDesc.PR35,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR35/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR35/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR35/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD11`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD11',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR35/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR11`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR11',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR35/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR15`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR15',
      },
    ],
    nextProduct: {
      id: 'PR36',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR36`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR36: {
    id: 'PR36',
    title: 'MR 6',
    text: 'Ludwig Littmann',
    year: '1981',
    theme: 'black',
    description: productDesc.PR36,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR36/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR36/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR36/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR06`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR06',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601464884/max-braun/products/PR36/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR13`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR13',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR36/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR47`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR47',
      },
    ],
    nextProduct: {
      id: 'PR37',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR37`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR39`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR39',
    },
  },
  PR37: {
    id: 'PR37',
    title: 'ABW 41',
    text: humanNames.HD10,
    year: '1981',
    theme: 'black',
    description: productDesc.PR37,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR37/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR37/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR37/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD10`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD10',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR37/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR30`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR30',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR37/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR41`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR41',
      },
    ],
    nextProduct: {
      id: 'PR38',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR38`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR38: {
    id: 'PR38',
    title: 'PGS 1200',
    text: 'Heinz Ullrich Haase',
    year: '1982',
    theme: 'black',
    description: productDesc.PR38,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR38/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR38/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR38/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR22`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR22',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR38/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR25`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR25',
      },
    ],
    nextProduct: {
      id: 'PR39',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR39`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR39: {
    id: 'PR39',
    title: 'KF 40',
    text: 'Hartwig Kahlcke',
    year: '1984',
    theme: 'black',
    description: productDesc.PR39,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR39/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR39/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR39/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR19`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR19',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1597906609/max-braun/products/PR39/Related.jpg',
        url: `${PATHS.PRODUCT}/PR28`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR28',
      },
    ],
    nextProduct: {
      id: 'PR40',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR40`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR35`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR35',
    },
  },

  PR40: {
    id: 'PR40',
    title: 'Lady Braun elegance 2',
    text: 'Roland Ullmann',
    year: '1985',
    theme: 'black',
    description: productDesc.PR40,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR40/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR40/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR40/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR27`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR27',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR40/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR44`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR44',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR40/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR51`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR51',
      },
    ],
    nextProduct: {
      id: 'PR41',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR41`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR41: {
    id: 'PR41',
    title: 'AB 1',
    text: humanNames.HD10,
    year: '1987',
    theme: 'black',
    description: productDesc.PR41,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR41/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR41/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR41/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD10`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD10',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR41/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR31`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR31',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR41/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR37`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR37',
      },
    ],
    nextProduct: {
      id: 'PR42',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR42`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },

  PR42: {
    id: 'PR42',
    title: 'AW 10',
    text: humanNames.HD10,
    year: '1989',
    theme: 'black',
    description: productDesc.PR42,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR42/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR42/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR42/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD10`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD10',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601467555/max-braun/products/PR42/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR33`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR33',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR42/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR46`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR46',
      },
    ],
    nextProduct: {
      id: 'PR43',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR43`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR43: {
    id: 'PR43',
    title: 'Syncro System 7570',
    text: 'Roland Ullman',
    year: '1999',
    theme: 'black',
    description: productDesc.PR43,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR43/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR43/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR43/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR34`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR34',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR43/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR48`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR48',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR43/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR52`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR52',
      },
    ],
    nextProduct: {
      id: 'PR44',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR44`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR49`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR49',
    },
  },

  PR44: {
    id: 'PR44',
    title: 'Silk-épil EE 300',
    text: humanNames.HD12,
    year: '1995',
    theme: 'black',
    description: productDesc.PR44,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR44/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR44/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR44/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD12`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD12',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR44/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR27`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR27',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR44/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR51`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR51',
      },
    ],
    nextProduct: {
      id: 'PR45',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR45`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },

  PR45: {
    id: 'PR45',
    title: 'IRT Pro 3000 Thermoscan',
    text: 'Jürgen Greubel, Ludwig Littmann',
    year: '1999',
    theme: 'black',
    description: productDesc.PR45,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/v1601465742/max-braun/products/PR45/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/v1601465759/max-braun/products/PR45/HeroMobile.jpg',
    relatedText: '',
    type: ELEMENT_TYPE.PRODUCT,
    related: [],
    nextProduct: {
      id: 'PR46',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR46`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR47`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR47',
    },
  },
  PR46: {
    id: 'PR46',
    title: 'BN0106',
    text: 'Braun Design & Studio Hannes Wettstein, Markus Orthey',
    year: '2011',
    theme: 'black',
    description: productDesc.PR46,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR46/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR46/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR46/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD15`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD15',
      },
    ],
    nextProduct: {
      id: 'PR47',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR47`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR47: {
    id: 'PR47',
    title: 'Multiquick 9',
    text: 'Markus Orthey, Ludwig Littmann',
    year: '2013',
    theme: 'black',
    description: productDesc.PR47,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR47/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR47/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR47/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD15`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD15',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601464863/max-braun/products/PR47/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR13`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR13',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR47/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR36`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR36',
      },
    ],
    nextProduct: {
      id: 'PR48',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR48`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR29`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR29',
    },
  },
  PR48: {
    id: 'PR48',
    title: 'Series 9',
    text: 'Oliver Grabes, Markus Orthey',
    year: '2014',
    theme: 'black',
    description: productDesc.PR48,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR48/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR48/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR48/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD15`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD15',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR48/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR34`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR34',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR48/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR54`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR54',
      },
    ],
    nextProduct: {
      id: 'PR49',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR49`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR53`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR53',
    },
  },
  PR49: {
    id: 'PR49',
    title: 'BN0171',
    text: humanNames.HD10,
    year: '2014',
    theme: 'black',
    description: productDesc.PR49,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR49/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR49/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1600683512/max-braun/products/PR49/Related1.jpg',
        url: `${PATHS.DESIGNER}/HD10`,
        type: ELEMENT_TYPE.DESIGNER,
        id: 'HD10',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR49/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR42`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR42',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR49/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR46`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR46',
      },
    ],
    nextProduct: {
      id: 'PR50',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR50`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR45`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR45',
    },
  },
  PR50: {
    id: 'PR50',
    title: 'IPL Silk-expert Pro 5',
    text: 'Braun Design',
    year: '2015',
    theme: 'black',
    description: productDesc.PR50,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR50/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR50/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR50/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR27`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR27',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR50/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR44`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR44',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR50/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR51`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR51',
      },
    ],
    nextProduct: {
      id: 'PR51',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR51`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR29`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR29',
    },
  },
  PR51: {
    id: 'PR51',
    title: 'Silk-épil 9 Flex',
    text: 'Braun Design',
    year: '2018',
    theme: 'black',
    description: productDesc.PR51,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR51/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR51/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR51/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR27`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR27',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR51/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR44`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR44',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR51/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR50`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR50',
      },
    ],
    nextProduct: {
      id: 'PR52',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR52`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR52: {
    id: 'PR52',
    title: 'Series 7',
    text: 'Braun Design',
    year: '2020',
    theme: 'black',
    description: productDesc.PR52,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR52/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR52/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR52/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR26`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR26',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR52/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR48`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR48',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR52/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR54`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR54',
      },
    ],
    nextProduct: {
      id: 'PR55',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR55`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR53: {
    id: 'PR53',
    title: 'LE01',
    text: 'Braun Design',
    year: '2020',
    theme: 'black',
    description: productDesc.PR53,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR53/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR53/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/v1601466352/max-braun/products/PR53/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR12`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR12',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR53/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR15`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR15',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR53/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR35`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR35',
      },
    ],
    nextProduct: {
      id: 'PR54',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR54`,
      type: ELEMENT_TYPE.PRODUCT,
    },
    nextProductInRoom: {
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR50`,
      type: ELEMENT_TYPE.PRODUCT,
      id: 'PR50',
    },
  },
  PR54: {
    id: 'PR54',
    classname: 'X Shaver',
    title: 'X Shaver',
    text: 'Braun Design',
    year: '2021',
    theme: 'black',
    description: productDesc.PR54,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR54/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR54/HeroMobile.jpg',
    image:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR54/Thumb_Big.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR54/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR43`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR43',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR54/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR48`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR48',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR54/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR52`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR52',
      },
    ],
    nextProduct: {
      id: 'PR01',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR01`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
  PR55: {
    id: 'PR55',
    title: 'MGK 7',
    text: 'Braun Design',
    year: '2019',
    theme: 'black',
    description: productDesc.PR55,
    imageLarge:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR55/Hero.jpg',
    imageMobile:
      'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR55/HeroMobile.jpg',
    relatedText: 'Related Content',
    type: ELEMENT_TYPE.PRODUCT,
    related: [
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR55/Related1.jpg',
        url: `${PATHS.PRODUCT}/PR26`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR26',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR55/Related2.jpg',
        url: `${PATHS.PRODUCT}/PR52`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR52',
      },
      {
        image:
          'https://res.cloudinary.com/arts/image/upload/max-braun/products/PR55/Related3.jpg',
        url: `${PATHS.PRODUCT}/PR54`,
        type: ELEMENT_TYPE.PRODUCT,
        id: 'PR54',
      },
    ],
    nextProduct: {
      id: 'PR53',
      text: general.nextProduct,
      url: `${PATHS.PRODUCT}/PR53`,
      type: ELEMENT_TYPE.PRODUCT,
    },
  },
};
